<script setup lang="ts">
import DisplayDeliveryPlanInformation from '@/components/DailyReportEdit/AlterLeaving/DisplayDeliveryPlanInformation.vue';
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import RegisterModal from '@/components/DailyReportEdit/Recreate/RegisterModal.vue';
import CompleteModal from '@/components/DailyReportEdit/Split/CompleteModal.vue';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { useAuth } from '@/services/user/Auth0UserProvider';
import Api from '@/services/api/ApiServiceFabrick';
import { ref, Ref } from 'vue';
import { useRouter } from 'vue-router';
import i18n from '@/lang/i18n';

const props = defineProps<{
  showFlash: (message: string, type: string, fadeout: boolean) => void
  deliveryPlan: getDeliveryPlanVehicleInformation
}>();

const { loginWithRedirect } = useAuth();
const router = useRouter();
const isProcessing: Ref<boolean> = ref(false);
const errorMessages = ref<{
  delivery_plan_id: string[]
}>({
  delivery_plan_id: []
});

const isLoading: Ref<boolean> = ref(false);
const isOpenDialog: Ref<boolean> = ref(false);
const isDisplayCompleteModal: Ref<boolean> = ref(false);

function moveDailyReportDisplay() {
  router.push({ name: "DailyReport" })
}

function execRecreate() {
  isLoading.value = true;
  errorMessages.value = {
    delivery_plan_id: []
  };

  Api().recreate(props.deliveryPlan.delivery_plan_id).then((data) => {
    if (data.status) {
      return isDisplayCompleteModal.value = true;
    }
    props.showFlash(i18n.global.t('pages.dailyReports.splitForm.failedMessage'), 'error', true);
  }).catch((error) => {
    errorHandler(error);
  }).finally(() => {
    isLoading.value = false;
  });
}

function errorHandler(error: any) {
  const res = error.response
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      location.reload()
      break
    case 422:
      errorMessages.value = res.data.errors
      if (errorMessages.value['delivery_plan_id']?.length) {
        isProcessing.value = true;
      }
  }
}
</script>
<template>
  <div class="d-flex" style="min-height: 45vw">
    <div class="content p-4 w-50 mx-auto">
      <v-card class="my-4 pa-4">
        <h4 class="card-title mt-0 mb-4">
          {{ i18n.global.t('pages.dailyReports.recreateForm.title') }}
        </h4>
        <v-row class="mt-2 mb-4 ml-12">
          <DisplayDeliveryPlanInformation
            :deliveryPlan="props.deliveryPlan"
          />
        </v-row>
        <div
          class="d-flex justify-content-end m-3"
        >
          <v-btn
            class="ma-2 reset-btn"
            :disabled="isLoading"
            @click="moveDailyReportDisplay"
          >
            {{ i18n.global.t('common.cancelBtn') }}
          </v-btn>
          <v-btn
            class="ma-2 exec-btn"
            :loading="isLoading"
            :disabled="isProcessing"
            @click="isOpenDialog = true"
          >
            {{ i18n.global.t('common.confirmBtn') }}
          </v-btn>
        </div>
        <ValidationErrors
          class="d-flex justify-content-end"
          :messages="errorMessages.delivery_plan_id"
        >
        </ValidationErrors>
      </v-card>
    </div>
  </div>
  <RegisterModal
    :title="i18n.global.t('pages.dailyReports.recreateConfirmModal.title')"
    v-model="isOpenDialog"
    :showFlash="props.showFlash"
    :execFunction="execRecreate"
  />
  <CompleteModal
    v-model="isDisplayCompleteModal"
    :messages="[
      i18n.global.t('pages.dailyReports.recreateCompleteModal.messageRow1'),
      i18n.global.t('pages.dailyReports.recreateCompleteModal.messageRow2')
    ]"
    :moveDailyReportDisplay="moveDailyReportDisplay"
  />
</template>
<style scoped>
.exec-btn-disabled {
  background-color: #B3B8BB;
}
</style>
